<template>
    <div>
        <div class="total">{{Math.round(usermission.total_score)}}</div>
        <b-progress :max="usermission.total_score" show-value height="1.25rem" style="min-width: 130px; margin-bottom: 5px; border-radius: 5px;">
            <b-progress-bar :value="usermission.teacher * 10" variant="primary" :title="$t('quest.teacher')" class="progress-lg" style="border-radius: 0px;"></b-progress-bar>
            <b-progress-bar :value="usermission.mission.difficulty" variant="warning" :title="$t('quest.difficulty')" style="border-radius: 0px;"></b-progress-bar>
            <b-progress-bar :value="usermission.bonus" variant="success" title="Bonus" v-if="usermission.bonus > 0" style="border-radius: 0px;"></b-progress-bar>
            <b-progress-bar :value="usermission.deadline_score" variant="danger" title="Deadline %" style="border-radius: 0px;"></b-progress-bar>
        </b-progress>
    </div>
</template>

<script>

    export default {
        props: ['usermission'],
        name: 'design-2021-quest-result-progress-bar-component',
        data() {
            return {
            }
        },
    }

</script>

<style scoped>
    .total {
        text-align: right;
        font-weight: bold;
    }
</style>